import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import ItemTypesManagementForm from "./item_types_management_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";


const ItemTypesManagementTable = ({
    rowKey = "",
    keyPrefix = "koha.item_types_management",
    showAllColumns = true,
    propsShowColumns,
    rowSelectType = 'checkbox',
    defaultSelectkeys = [], //selectkeys
    defaultSelectInfos = [], //selectInfo
    onSelectChange = () => { }, //selectInfo
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })

    const columns = [
        {
            title: t("itemtype"),
            key: "itemtype",
            dataIndex: "itemtype",
            align: "center",
        },
        {
            title: t("parent_type"),
            key: "parent_type",
            dataIndex: "parent_type",
            align: "center",
        },
        {
            title: t("description"),
            key: "description",
            dataIndex: "description",
            align: "center",
        },
        {
            title: t("rentalcharge"),
            key: "rentalcharge",
            dataIndex: "rentalcharge",
            align: "center",
        },
        {
            title: t("rentalcharge_daily"),
            key: "rentalcharge_daily",
            dataIndex: "rentalcharge_daily",
            align: "center",
        },
        {
            title: t("rentalcharge_daily_calendar"),
            key: "rentalcharge_daily_calendar",
            dataIndex: "rentalcharge_daily_calendar",
            align: "center",
            render: (text, record, index) => {
                if (!!parseInt(text)) {
                    return <Tag color="success">{t('open')}</Tag>
                }
                else {
                    return <Tag color="error">{t('close')}</Tag>
                }
            }
        },
        {
            title: t("rentalcharge_hourly"),
            key: "rentalcharge_hourly",
            dataIndex: "rentalcharge_hourly",
            align: "center",
        },
        {
            title: t("rentalcharge_hourly_calendar"),
            key: "rentalcharge_hourly_calendar",
            dataIndex: "rentalcharge_hourly_calendar",
            align: "center",
            render: (text, record, index) => {
                if (!!parseInt(text)) {
                    return <Tag color="success">{t('open')}</Tag>
                }
                else {
                    return <Tag color="error">{t('close')}</Tag>
                }
            }
        },
        {
            title: t("defaultreplacecost"),
            key: "defaultreplacecost",
            dataIndex: "defaultreplacecost",
            align: "center",
        },
        {
            title: t("processfee"),
            key: "processfee",
            dataIndex: "processfee",
            align: "center",
        },
        {
            title: t("notforloan"),
            key: "notforloan",
            dataIndex: "notforloan",
            align: "center",
            render: (text, record, index) => {
                if (!!parseInt(text)) {
                    return <Tag color="success">{t('open')}</Tag>
                }
                else {
                    return <Tag color="error">{t('close')}</Tag>
                }
            }
        },
        {
            title: t("summary"),
            key: "summary",
            dataIndex: "summary",
            align: "center",
        },
        {
            title: t("checkinmsg"),
            key: "checkinmsg",
            dataIndex: "checkinmsg",
            align: "center",
        },
        {
            title: t("checkinmsgtype"),
            key: "checkinmsgtype",
            dataIndex: "checkinmsgtype",
            align: "center",
        },
        // {
        //     title: t("sip_media_type"),
        //     key: "sip_media_type",
        //     dataIndex: "sip_media_type",
        //     align: "center",
        // },
        {
            title: t("hideinopac"),
            key: "hideinopac",
            dataIndex: "hideinopac",
            align: "center",
            render: (text, record, index) => {
                if (!!parseInt(text)) {
                    return <Tag color="success">{t('open')}</Tag>
                }
                else {
                    return <Tag color="error">{t('close')}</Tag>
                }
            }
        },
        //搜尋類別不太確定的功能
        // {
        //     title: t("searchcategory"),
        //     key: "searchcategory",
        //     dataIndex: "searchcategory",
        //     align: "center",
        // },
        {
            title: t("automatic_checkin"),
            key: "automatic_checkin",
            dataIndex: "automatic_checkin",
            align: "center",
            render: (text, record, index) => {
                if (!!parseInt(text)) {
                    return <Tag color="success">{t('open')}</Tag>
                }
                else {
                    return <Tag color="error">{t('close')}</Tag>
                }
            }
        },
        {
            title: t("branches"),
            key: "branches",
            dataIndex: "branches",
            align: "center",
            render: (text, record, index) => {
                let branches = text || []
                console.log({
                    branches
                })
                if (branches?.length === 0) {
                    return <Tag>{t('all_select')}</Tag>
                }
                else {
                    return <Row>
                        <Col span={24}>
                            <Row>
                                {
                                    branches?.map((value) => {
                                        return <Col>
                                            <Tag>
                                                {value?.branchcode} {value?.branchname}
                                            </Tag>
                                        </Col>
                                    })
                                }
                            </Row>
                        </Col>
                    </Row>
                }
            }
        },

    ];
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ['question_and_answer_data', 'title'])

    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20);
    const [selectedRowKeys, setSelectedRowKeys] = useState(defaultSelectkeys ? defaultSelectkeys : []);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState(defaultSelectInfos ? defaultSelectInfos : []);
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                changeRows.forEach((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.forEach((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys];
            let selectRow = [...selectedRowsInfo];
            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter((key) => key !== record?.[rowKey]);
                selectRow = selectRow.filter((row) => row?.[rowKey] !== record?.[rowKey]);
            }
            setSelectedRowKeys((pre) => select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };
    const [modalOpen, setModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const [form] = Form.useForm();


    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }

    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true);
    };


    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useProTableOt({
        columns,
    });
    const ItemTypesManagementController = useCRUDController({
        apiRoute: "/koha/itemtypes",
        onFinish,
        onBefore
    })
    useEffect(() => {
        checkAll();

    }, []);
    useEffect(() => {
        onSelectChange(selectedRowsInfo)
    }, [selectedRowsInfo])
    return (<Row>
        <Col span={24}>
            <ProTableOt
                formMode={true}
                actionRef={actionRef}
                headerTitle={
                    <>

                    </>
                }
                columns={showAllColumns ? columns : columns.filter((element) => {
                    return showColumns.includes(element?.key)
                })}
                check={check}
                setCheck={setCheck}
                rowKey={rowKey}

                toolBarRender={() => {
                    return []
                }}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    let newParams = {};
                    let order = setOrders(sort);
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params?.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20);

                    return ItemTypesManagementController.getData(newParams);
                    // return []
                }}
                pageSize={pageSize}
                rowSelection={
                    {
                        type: rowSelectType,
                        selectedRowKeys: selectedRowKeys,
                        selectedRowsInfo: selectedRowsInfo,
                        setSelectedRowKeys: setSelectedRowKeys,
                        setSelectedRowsInfo: setSelectedRowsInfo,
                        ...rowSelection,
                    }
                }

                propsPatchProcess={(data) => {
                    let branches = data?.branches || []
                    branches = branches?.map((val) => {
                        return val?.branchcode
                    })
                    if (branches.length === 0) {
                        branches = [""]
                    }

                    return {
                        ...data,
                        branches,
                        axiosMode: "patch"
                    }
                }}
                initialValues={{
                    "itemtype": null,
                    // "parent_type": null,
                    "description": null,
                    "rentalcharge": "0",
                    "rentalcharge_daily": "0",
                    "rentalcharge_daily_calendar": 0,
                    "rentalcharge_hourly": "0",
                    "rentalcharge_hourly_calendar": 0,
                    "defaultreplacecost": "0",
                    "processfee": "0",
                    "notforloan": 0,
                    "imageurl": "",
                    "summary": "",
                    "checkinmsg": "",
                    "checkinmsgtype": "message",
                    "sip_media_type": null,
                    "hideinopac": 0,
                    "searchcategory": null,
                    "automatic_checkin": 0,
                    "branches": [""],
                    "axiosMode": "post",
                }}
                propsPostOnBefore={(data) => {
                    let branches = data?.branches || []
                    branches = branches?.map((val) => {
                        return val?.branchcode
                    })
                    if (branches.length === 0) {
                        branches = [""]
                    }

                    return {
                        ...data,

                        axiosMode: "post"
                    }
                }}
                propsUseData={() => {
                    return {
                        postData: (formData) => {

                            let postData = formData.map((formValue) => {
                                let branches = formValue?.branches || []
                                if (branches.includes("")) {
                                    branches = null
                                }
                                else {
                                    branches = branches?.map((value) => {
                                        return {
                                            branchcode: value
                                        }
                                    })
                                }
                                return {
                                    ...formValue,
                                    branches
                                }

                            })
                            ItemTypesManagementController.postData(postData)
                        },
                        patchData: (formData) => {
                            let patchData = formData.map((formValue) => {
                                let branches = formValue?.branches || []
                                if (branches.includes("")) {
                                    branches = null
                                }
                                else {
                                    branches = branches?.map((value) => {
                                        return {
                                            branchcode: value
                                        }
                                    })
                                }
                                return {
                                    ...formValue,
                                    branches
                                }
                            })
                            ItemTypesManagementController.patchData(patchData)
                        },
                        deleteData: ItemTypesManagementController.deleteData
                    }
                }}
                PropsPatchForm={<ItemTypesManagementForm />}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                propsPatch={permission_level === 1 ? true : false}
                propsDelete={permission_level === 1 ? true : false}
                propsPost={permission_level === 1 ? true : false}
                propsWidth={1600}
                scroll={{
                    x: "100%",
                }}
            />
        </Col>
    </Row>)

}
const ItemTypesManagement = ({
    keyPrefix = "koha.item_types_management",
    permission_level = null, 
}) => {
    return (
        <Row
            gutter={[10, 20]}
        >
            <Col span={24}>
                <ItemTypesManagementTable keyPrefix={keyPrefix} permission_level={permission_level} />
            </Col>
        </Row>
    );
};
export { ItemTypesManagementTable }
export default ItemTypesManagement;
